// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import MainPage from "./pages/MainPage";
import BigDatabasePage from "./pages/BigDatabasePage";
import ConvertFormulaPage from "./pages/ConvertFormulaPage";
import LoginPage from "./pages/LoginPage";
import LegacyBlacklistPage from "./pages/LegacyBlacklistPage"; // <-- added
import { auth, onAuthStateChanged, logout } from "./data/auth";

import { SpeedInsights } from "@vercel/speed-insights/react"

// // unused
// const ALLOWED_UIDS = [
//   "3Ix7KfxyFMcll14Torfw9miLlMi1",
//   "PAlXRWAAckSznVfcYrEsPZyoyEE3",
//   "BhMhhBn2cSfRN4ZXiou6mTXZerT2",
//   "XBPhFdlV3TYWYkOqxuoFT4UI6RQ2"
// ];

export default function App() {
  const [ready, setReady] = React.useState(false);
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    const unsub = onAuthStateChanged(auth, u => {
      setUser(u || null);
      setReady(true);
    });
    return () => unsub();
  }, []);

  if (!ready) return null;
  if (!user) return <LoginPage />;

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/add" element={<MainPage />} />
        <Route path="/search" element={<MainPage />} />
        <Route path="/big" element={<BigDatabasePage />} />
        <Route path="/convert" element={<ConvertFormulaPage />} />
        <Route path="/legacy-blacklist" element={<LegacyBlacklistPage />} /> {/* <-- added */}
        <Route path="*" element={<Navigate to="/add" replace />} />
      </Routes>
    </Router>
  );
}

const styles = {
  btn: { background: "#fff", border: "1px solid #ddd", borderRadius: 6, padding: "6px 10px", cursor: "pointer" },
  deniedWrap: { minHeight: "100vh", display: "grid", placeItems: "center", background: "#f6f7f8", padding: 24 },
  deniedCard: { maxWidth: 560, background: "#fff", border: "1px solid #e6e7e8", borderRadius: 10, padding: 24, boxShadow: "0 6px 24px rgba(0,0,0,0.08)" },
};
